import {
  ChakraFlex,
  ChakraSpacer,
  FAIconName,
  FireflyButton,
} from '@equip.health/ui';

import { NoteEvents } from '~/analytics';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

type Props = {
  dismissAccordion: () => void;
  isAnyNoteApiInFlight: boolean;
  isUpdateNoteLoading: boolean;
  onSaveSignedConfirm: () => void;
};

export const EditNoteAccordionAddendumFooter = ({
  dismissAccordion,
  isAnyNoteApiInFlight,
  isUpdateNoteLoading,
  onSaveSignedConfirm,
}: Props) => {
  const { trackEvent } = useAnalytics();
  return (
    <ChakraFlex alignItems="center" gap="36px" marginTop="12px" w="100%">
      <ChakraSpacer />
      <FireflyButton
        id="add-addendum__cancel"
        onClick={() => {
          trackEvent(NoteEvents.cancelAddendumNotesTabButtonClicked, {
            Source: AnalyticsSourceValues.NOTES_TAB,
          });
          dismissAccordion();
        }}
        variant="tertiary"
      >
        Cancel
      </FireflyButton>
      <FireflyButton
        id="add-addendum__submit"
        isDisabled={isAnyNoteApiInFlight}
        isLoading={isUpdateNoteLoading}
        onClick={() => {
          trackEvent(NoteEvents.submitAddendumNotesTabButtonClicked, {
            Source: AnalyticsSourceValues.NOTES_TAB,
          });
          onSaveSignedConfirm();
        }}
        rightIcon={FAIconName.checkRegular}
      >
        Submit addendum
      </FireflyButton>
    </ChakraFlex>
  );
};
